<template>
  <div>

    <div class="v-input v-input--is-label-active v-input--is-dirty v-input--dense theme--light v-text-field v-text-field--is-booted v-text-field--enclosed v-text-field--outlined">
      <div class="v-input__control">
        <div class="v-input__slot">
          <fieldset aria-hidden="true">
            <legend style="width: 112px;">
              <span></span>
            </legend>
          </fieldset>

          <div class="v-text-field__slot" style="width:100%">
            <label class="v-label v-label--active theme--light" style="left: 0px; margin-top: -7px; right: auto; position: absolute;">
              {{ label }}
            </label>

            <div style="width:100%; padding:10px 10px 20px 10px" fill-height fluid>
              <v-row align="center" justify="center">
                <v-progress-circular
                  :size="28"
                  v-if="loadingEntry"
                  color="primary"
                  indeterminate
                ></v-progress-circular>

                <v-icon
                  style="margin-top:20px; margin-bottom:10px"
                  color="grey-darken1"
                  :size="86"
                  v-else-if="!this.nodesSelected"
                >{{ icon }}</v-icon>

                <div class="col" v-else>
                  <v-img
                    class="white--text align-center img-bg custom-thumb"
                    width="100%"
                    v-if="thumbUrl"
                    :src="thumbUrl"
                    align="center"
                    justify="center"
                    contain
                  ></v-img>

                  <v-icon
                    v-else
                    :color="thumbIcon.color || 'defaultIconColor'"
                    size="36"
                  >{{ thumbIcon.icon }}</v-icon>
                </div>
              </v-row>

              <div class="row" :style="nodesSelected ? 'height:32px' : ''">
                <div class="text" v-if="loadingEntry">
                  {{ $t('Loading...') }}
                </div>

                <div
                  class="col text-center"
                  v-else-if="!nodesSelected"
                >
                  <a @click="selectFile()">
                    {{ $t(clickText) }}
                  </a>
                    {{ $t(selectText) }}
                </div>

                <v-row v-if="nodesSelected" class="ma-0 filename-container">
                  <v-col cols="10" class="pa-1">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <div
                          v-bind="attrs"
                          v-on="on"
                          class="filename-text-wraper"
                        >{{ selectedNodes[0]?.name || '' }}</div>
                      </template>
                      <span>{{ selectedNodes[0]?.name || '' }}</span>
                    </v-tooltip>
                  </v-col>

                  <v-col cols="2" class="d-flex pa-0 justify-center">
                    <v-btn
                      @click="resetSelectedNodes"
                      icon
                    >
                      <v-icon>mdi-close-circle-outline</v-icon>
                    </v-btn>
                  </v-col>
                </v-row>
              </div>
            </div>
          </div>
          <slot name="append"></slot>
        </div>
      </div>
    </div>

    <v-text-field
      v-show="false"
      :value="value"
      :name="name"
    ></v-text-field>

    <v-dialog
      class="navModal"
      v-model="navModal"
      width="70%"
      style="z-index: 10002;"
      :persistent="persistent"
      scrollable
    >
      <v-card class="navContainer">
        <v-card-title class="d-flex align-center">
          <span class="mr-4">{{ $t(modalTitle) }}</span>
          <v-spacer></v-spacer>
          <v-text-field
            v-model="searchTerm"
            :label="$t('search')"
            dense
            clearable
            hide-details
            append-icon="mdi-magnify"
            style="max-width: 320px;"
            @keydown.enter="searchValueChanged"
            @click:append="searchValueChanged"
            @click:clear="clearSearch"
          />
          <SelectionBasket
            v-if="basketEnabled && navModal"
            :selected-nodes="selectedNodes"
            @remove="removeSelectedNodes"
          />
        </v-card-title>

        <v-card-text style="height: 500px">
          <Breadcrumbs
            :items="formattedBreadcrumbs"
            maxWidthItem="25%"
            class="breadcrumb"
            @breadcrumbNav="breadcrumbNav"
            v-if="parentNodeId && !loadingEntries"
          />

          <v-row
            class="fill-height"
            align-content="center"
            justify="center"
            v-if="!parentNodeId"
          >
            <v-col
              class="text-subtitle-1 text-center"
              cols="12"
            >
              <span>{{ 'Parent NodeID not found.' }}</span>
            </v-col>
          </v-row>

          <v-row
            class="fill-height"
            align-content="center"
            justify="center"
            v-if="parentNodeId && loadingEntries"
          >
            <v-col
              class="text-subtitle-1 text-center"
              cols="12"
            >
              <span v-if="loadingEntries">{{ $t('retrieving_files') }}</span>

              <span v-else>{{ $t('empty_folder') }}</span>
            </v-col>

            <v-col
              v-if="loadingEntries"
              cols="6"
            >
              <v-progress-linear
                color="primary"
                indeterminate
                rounded
                height="6"
              ></v-progress-linear>
            </v-col>
          </v-row>

          <v-row v-if="folders.length > 0 && !loadingEntries">
            <v-col
              class="py-2 px-2"
              v-for="item in folders"
              :key="item.node_id"
              xl="2"
              lg="3"
              md="4"
              sm="6"
              cols="12"
            >
              <FolderCard
                dense
                :data="item"
                :disable-actions-menu="acceptsFolders"
                :selectable="!filesOnly"
                @click-folder="onFolderClick"
                @toggle-selection="toggleSelection"
                :ref="'folderCardRef' + item.node_id"
              />
            </v-col>
          </v-row>
          <v-row v-if="files.length > 0 && !loadingEntries">
            <v-col
              v-for="item in files"
              :key="item.node_id"
              class="d-flex child-flex py-2 px-2"
              xl="2"
              lg="3"
              md="4"
              sm="6"
              cols="12"
            >
              <FileCard
                :data="item"
                disable-actions-menu
                @toggle-selection="toggleSelection"
                :ref="'fileCardRef' + item.node_id"
              />
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="cancelSelection">{{ $t('cancel') }}</v-btn>
          <v-btn
            text
            @click="confirmSelection"
            color="primary"
            :loading="loadingEntry"
            :disabled="loadingEntries || (!selectedNodesIds.length && !canSelectCurrentFolder)"
          >{{ $t('select') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<style scoped>
  .component {
    cursor: pointer;
    padding: 0;
    margin-bottom: 20px;
    height: 68px;
  }

  .navContainer h2 {
    margin-bottom: 10px;
    color: var(--v-secondary-darken1);
    font-weight: 500;
  }

  .breadcrumb {
    margin-bottom: 20px;
  }

  .img-bg {
    background-color: #DADCE0;
  }

  .filename-container {
    width: 100% !important;
  }

  .filename-text-wraper {
    white-space: nowrap !important;
    overflow: hidden !important;
    text-overflow: ellipsis !important;
  }
</style>

<script>

import SelectionBasket from '@/components/content/SelectionBasket.vue'
import _ from 'lodash'
import api from '@/services/api'
import { mapActions } from 'vuex'
import Breadcrumbs from '@/components/Breadcrumbs.vue'
import FolderCard from '@/components/content/FolderCard.vue'
import FileCard from '@/components/content/FileCard.vue'
import EntryActions from '@/store/content/entry/actions-types'
import IconsByMimetype from '@/utils/iconsByMimetype.js'

export default {
  name: 'SelectFileField',

  components: {
    SelectionBasket,
    Breadcrumbs,
    FolderCard,
    FileCard
  },

  props: {
    label: {
      type: String
    },

    icon: {
      type: String,
      default: 'mdi-file-outline'
    },

    iconColor: {
      type: String,
      default: 'defaultIconColor'
    },

    accepts: {
      type: String
    },

    clickText: {
      type: String,
      default: 'click_here'
    },

    selectText: {
      type: String,
      default: 'to_select_a_file'
    },

    modalTitle: {
      type: String,
      default: 'select_a_file'
    },

    parentNodeId: {
      type: Number
    },

    multipleSelect: {
      type: Boolean,
      default: false
    },

    selectionBasket: {
      type: Boolean,
      default: false
    },

    filesOnly: {
      type: Boolean,
      default: false
    },

    name: {
      type: String
    },

    value: {
      type: [Array, Number, String]
    },

    rootLabel: {
      type: String,
      default: ''
    },

    allowRootNav: {
      type: Boolean,
      default: true
    },

    rootNavBehavior: {
      type: String,
      default: 'emit' // 'emit' | 'navigate'
    },

    persistent: {
      type: Boolean,
      default: false
    },

    blockedNodeIds: {
      type: Array,
      default: () => []
    },

    blockedRootId: {
      type: [String, Number],
      default: null
    }
  },

  mounted() {
    if (this.value && !this.nodesSelected) {
      this.retrieveEntryData()
    }
  },

  watch: {
    value(val) {
      if (!val) {
        this.resetSelectedNodes()
        return
      }

      this.retrieveEntryData()
    },
    navModal(val) {
      if (!val) {
        this.restoreConfirmedSelection()
      }
      this.$emit(val ? 'opened' : 'closed')
    }
  },

  data: function() {
    return {
      navModal: false,
      loadingEntries: false,
      breadcrumb: [],
      entries: [],
      selectedNodesIds: [],
      selectedNodes: [],
      confirmedNodesIds: [],
      confirmedNodes: [],
      nodesSelected: false,
      loadingEntry: false,
      searchTerm: '',
      currentParentId: null,
    }
  },

  computed: {
    canSelectCurrentFolder() {
      return this.selectCurrentFolder && this.acceptsFolders &&
        !!this.currentParentId &&
        String(this.currentParentId) !== String(this.parentNodeId) &&
        !this.isBlocked(this.currentParentId, true)
    },

    basketEnabled() {
      return this.multipleSelect && this.selectionBasket
    },

    formattedBreadcrumbs() {
      let first = {
        prependIcon: 'mdi-home-outline',
        iconColor: 'secondary',
        disabled: false,
        ripple: false,
        tooltipText: this.rootLabel || "Home",
        nodeId: this.parentNodeId,
        text: this.rootLabel || '',
        event: 'breadcrumbNav',
        link: true
      }

      if (!this.breadcrumb || this.breadcrumb.length < 2) {
        return [first]
      }

      first['iconColor'] = 'primary'

      const formatted = []
      formatted.push(first)

      const reversed = [].concat(this.breadcrumb).reverse()
      reversed.shift()

      const last = reversed.pop()

      reversed.forEach(element => {
        formatted.push({
          event: 'breadcrumbNav',
          text: element.name,
          ripple: false,
          nodeId: element.node_id,
          color: 'primary'
        })
      })

      formatted.push({
        text: last.name,
        ripple: false
      })

      return formatted
    },

    folders() {
      let folders = this.entries.filter(e => e.type == "folder" && !  /^\..*/.test(e.name))

      return this.orderItems(folders)
    },

    acceptsFolders() {
      if (!this.accepts) {
        return false
      }
      return this.accepts.toLowerCase().includes('folder')
    },

    files() {
      let files = this.orderItems(this.entries.filter(e => e.type == "file" && ! /^\..*/.test(e.name)))

      return files
    },

    thumbIcon() {
      const selectedNode = this.selectedNodes[0]

      if (! selectedNode) {
        return ''
      }

      if (selectedNode.node_type == 'folder') {
        return 'mdi-folder'
      }

      return IconsByMimetype.getIconByMimetype(selectedNode.extension, selectedNode.mime)
    },

    thumbUrl() {
      if (this.selectedNodes.length == 0) {
        return false
      }

      if (Array.isArray(this.selectedNodes[0].renditions)) {
        return this.selectedNodes[0].renditions[0]
      }

      if (typeof this.selectedNodes[0].renditions === 'object') {
        return Object.values(this.selectedNodes[0].renditions)[0]
      }

      return false;
    }
  },

  methods: {
    ...mapActions('content/entry', [
      EntryActions.GET_ENTRY_DATA,
      EntryActions.LIST_SUBFOLDER
    ]),

    async searchValueChanged() {
      const term = (this.searchTerm || '').trim()
      if (!term) return
      this.loadingEntries = true
      try {
        // Restrict search to the base node
        const base = this.currentParentId || this.parentNodeId
        const params = { term, 'filters[base_node_id]': base }
        const res = await api.content.search.searchByTerm(params)
        const items = res?.data || []
        // Filter based on accepts prop
        const filtered = items.filter(entry => {
          if (!this.accepts) return true
          
          // Handle file mime type filter
          if (entry.type === 'file') {
            const acceptsWithoutFolder = this.accepts.replace(/folder,?/gi, '').trim()
            if (!acceptsWithoutFolder) return false
            return (entry.mime || '').toLowerCase().match(acceptsWithoutFolder.toLowerCase()) !== null
          }
          
          return false
        })
        this.entries = filtered
        this.breadcrumb = []
      } catch (e) {
        console.error('Search error:', e)
      } finally {
        this.loadingEntries = false
        this.toggleSelected()
      }
    },

    clearSearch() {
      this.searchTerm = ''
      const base = this.currentParentId || this.parentNodeId
      if (base) {
        this.navigate(base)
      }
    },

    selectFile() {
      this.restoreConfirmedSelection()
      this.searchTerm = ''
      this.navModal = true

      if (!this.parentNodeId) {
        return
      }

      this.currentParentId = this.parentNodeId
      this.navigate(this.parentNodeId)
    },

    onFolderClick(folder) {
      const targetId = folder?.node_id || folder
      if (!targetId) {
        return
      }

      if (this.isBlocked(targetId)) {
        return
      }

      this.navigate(targetId)
    },

    toggleSelection(nodeId) {
      if (this.selectedNodesIds.some(id => String(id) === String(nodeId))) {
        this.removeSelectedNodes([nodeId])
      } else {
        const node = this.entries.find(entry => String(entry.node_id) === String(nodeId))
        if (!node || !this.isSelectableNode(node)) return
        this.selectedNodes = this.multipleSelect ? [...this.selectedNodes, node] : [node]
        this.selectedNodesIds = this.selectedNodes.map(entry => entry.node_id)
        this.toggleSelected()
      }
    },

    removeSelectedNodes(nodeIds) {
      const removedIds = new Set(nodeIds.map(String))
      this.selectedNodes = this.selectedNodes.filter(node => !removedIds.has(String(node.node_id)))
      this.selectedNodesIds = this.selectedNodes.map(node => node.node_id)
      this.toggleSelected()
    },

    navigate(parentId) {
      if (!this.basketEnabled) {
        this.selectedNodes = []
        this.selectedNodesIds = []
        this.nodesSelected = false
      }
      this.loadingEntries = true

      if (this.isBlocked(parentId, true)) {
        this.loadingEntries = false
        this.currentParentId = parentId
        this.breadcrumb = []
        this.entries = []
        return
      }

      this[EntryActions.LIST_SUBFOLDER]({parentId})
        .then((data) => {
          this.loadingEntries = false
          this.currentParentId = parentId
          this.breadcrumb = data.breadcrumb
          this.entries = data.entries.filter(entry => {
            if (this.isBlocked(entry.node_id)) {
              return false
            }
            if (!this.accepts) {
              return true
            }

            // Handle folder filter
            if (entry.type === 'folder') {
              return this.acceptsFolders
            }

            // Handle file mime type filter
            if (entry.type === 'file') {
              const acceptsWithoutFolder = this.accepts.replace(/folder,?/gi, '').trim()
              if (!acceptsWithoutFolder) return false
              return entry.mime.toLowerCase().match(acceptsWithoutFolder.toLowerCase()) !== null
            }

            return false
          })
          this.toggleSelected()
        })
    },

    orderItems(items) {
      const notNullFilters = _.pickBy(this.orderBy)

      if (_.isEmpty(notNullFilters)) {
        return items
      }

      return _.orderBy(items, _.keys(notNullFilters), _.values(notNullFilters))
    },

    breadcrumbNav(item) {
      if (item.nodeId === this.parentNodeId) {
        if (!this.allowRootNav) {
          return
        }

        if (this.rootNavBehavior === 'navigate') {
          this.navigate(this.parentNodeId)
        } else {
          this.navModal = false
          this.$emit('rootNav')
        }
        return
      }

      this.navigate(item.nodeId)
    },

    toggleSelected() {
      this.$nextTick(() => {
        for (const prop in this.$refs) {
          if (prop.startsWith('fileCardRef') || prop.startsWith('folderCardRef')) {
            const nodeId = prop.substring(prop.indexOf('Ref') + 3)
            const card = this.$refs[prop][0]
            if (card) {
              card.markSelectionAs(this.selectedNodesIds.some(id => String(id) === nodeId))
            }
          }
        }
      })
    },

    async confirmSelection() {
      if (this.loadingEntries || this.loadingEntry) return

      if (!this.selectedNodesIds.length) {
        if (!this.canSelectCurrentFolder) return

        const parentId = this.currentParentId
        this.loadingEntry = true
        try {
          const node = await this[EntryActions.GET_ENTRY_DATA](parentId)
          if (!this.navModal || this.currentParentId !== parentId ||
              !node || (node.type || node.node_type) !== 'folder' ||
              this.isBlocked(node.node_id, true)) return

          this.selectedNodes = [node]
          this.selectedNodesIds = [node.node_id]
          this.dispatchSelectNodes(this.selectedNodes)
        } catch (error) {
          console.error('Error selecting current folder:', error)
        } finally {
          this.loadingEntry = false
        }
        return
      }

      this.dispatchSelectNodes()
    },


    dispatchSelectNodes() {
      const candidates = this.basketEnabled
        ? [...this.selectedNodes]
        : this.entries.filter(entry => this.selectedNodesIds.indexOf(entry.node_id) > -1)
      const selectedNodes = candidates.filter(this.isSelectableNode)

      this.selectedNodes = selectedNodes
      this.selectedNodesIds = selectedNodes.map(node => node.node_id)
      this.confirmedNodes = [...selectedNodes]
      this.confirmedNodesIds = [...this.selectedNodesIds]
      this.$emit('selectNodes', selectedNodes)

      this.navModal = false

      this.markSelectedNodesIds()
    },

    markSelectedNodesIds() {
      this.nodesSelected = this.selectedNodesIds.length > 0
    },

    resetSelectedNodes() {
      this.selectedNodes = []
      this.selectedNodesIds = []
      this.confirmedNodes = []
      this.confirmedNodesIds = []
      this.nodesSelected = false
      this.dispatchSelectNodes()
    },

    retrieveEntryData() {
      if (this.nodesSelected) {
        return
      }

      if (Array.isArray(this.value)) {
        this.value.forEach((nodeId) => {
          this.getAndPushNodeById(nodeId)
        })

        return
      }

      this.getAndPushNodeById(this.value)
    },

    getAndPushNodeById(nodeId) {
      this.loadingEntry = true
      this[EntryActions.GET_ENTRY_DATA](nodeId)
        .then((data) => {
          if (data && this.isSelectableNode(data) && !this.isBlocked(data.node_id || nodeId, true)) {
            this.selectedNodes.push(data)
            this.selectedNodesIds.push(nodeId)
            this.confirmedNodes = [...this.selectedNodes]
            this.confirmedNodesIds = [...this.selectedNodesIds]
            this.markSelectedNodesIds()
          }
          this.loadingEntry = false
        })
    }

    ,
    isBlocked(id, includeRoot = false) {
      if (!id) return false
      const strId = String(id)
      if (this.blockedNodeIds.some(b => String(b) === strId)) {
        return true
      }
      if (includeRoot && this.blockedRootId && String(this.blockedRootId) === strId) {
        return true
      }
      return false
    },

    isSelectableNode(node) {
      return !this.filesOnly || (node.type || node.node_type) === 'file'
    },

    cancelSelection() {
      this.navModal = false
      this.restoreConfirmedSelection()
    },

    restoreConfirmedSelection() {
      this.selectedNodes = [...this.confirmedNodes]
      this.selectedNodesIds = [...this.confirmedNodesIds]
      this.nodesSelected = this.confirmedNodesIds.length > 0
    }
  }
}

</script>
